import MerchantSelector from './MerchantSelector';

export default MerchantSelector;
